import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from '../useTexts'

export function ErrorBody() {
  const texts = useTexts()

  return (
    <Alert severity="error" icon={false}>
      <AlertTitle>{texts.errorTitle}</AlertTitle>
      {texts.errorDescription}
    </Alert>
  )
}
